module.exports = __webpack_public_path__ + "static/Time_to_PCI-13bcf2801139822ed23f0014acada972.jpg";